// Input component used in many components in chart controls section

import React, { useState,useEffect } from 'react';

const InputNumber = ({

	value,
	updateValue,
	disabled,
	style,
}: {
	value: any;
	updateValue: any;
	disabled: boolean;
	style?: React.CSSProperties;

}) => {
  const [inputValue, setInputValue] = useState<any>(value);

  useEffect(() => {
    if (disabled) {
      setInputValue("");  
    } else {
      setInputValue(value); 
    }
  }, [value, disabled]);

  const checkInput = (inputValue: string | number) => {
    if (Number.isInteger(Number(inputValue))) {
      updateValue(Number(inputValue));
    } else {
      setInputValue(' ');
    }
  };
  return (
    <form
      style={{ margin: '0 10px' }}
      onSubmit={(evt: any) => {
        evt.currentTarget.querySelector('input').blur();
        evt.preventDefault();
        // checkInput();
      }}
    >
      <input
        disabled={disabled}
        className="inputValue border"
        type="number"
        value={inputValue}
        onBlur={() => checkInput(inputValue)}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        style={{
          padding: "4px 10px 2px 8px",
          border: '1px solid rgba(0, 0, 0, 0.23)',
          borderRadius: '4px',
          outline: 'none',
          backgroundColor: 'white',
        
        }}
      />
    </form>
  );
};

export default InputNumber;
